<template>
    <div id="editNotificate">
      <!-- 提示框(自动消失) -->
      <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" :closeOnClickModal="false">
          <span>{{tips}}</span>
          <span slot="footer" class="dialog-footer">
              <!-- <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button> -->
          </span>
      </el-dialog>

      <!-- 确认提示框 -->
      <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsSureVisible" :modal-append-to-body="false">
          <div>{{tipsTwo}}</div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogTipsSureVisible = false">取 消</el-button>
              <el-button type="primary" @click="TipsSure()">确 定</el-button>
          </div>
      </el-dialog>

      <!-- 保存未发布时，无法置顶确认提示框 -->
      <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsSureVisible1" :modal-append-to-body="false">
          <div>保存未发布时，无法置顶，是否继续保存？</div>
          <div slot="footer" class="dialog-footer">  
            <el-button @click="dialogTipsSureVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="TipsSure1()">确 定</el-button>
          </div>
      </el-dialog>

      <!-- 返回提示框 -->
      <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsBackVisible" :modal-append-to-body="false">
          <div>{{tipsBack}}</div>
          <div slot="footer" class="dialog-footer">
            <el-button v-if="isAuth('notice:saveNotice')"  @click="issueClick(0)">保 存</el-button>
            <el-button  @click="BackSaveNo()">不保存</el-button>
            <el-button @click="dialogTipsBackVisible = false">取 消</el-button>
          </div>
      </el-dialog>

      <!-- 预览公告 -->
      <el-dialog
        top='0'
        :showClose="false"
        :visible.sync="dialogVisible5"
        width="60%"
        height="calc(100%)"
        class="board">
        <div class="boardTitle"> 
          <div>{{ruleForm.editValue}}</div>
          <div>发布时间：{{ruleForm.publicDate}}</div>
        </div>

        <div class="ql-container ql-snow" style="border:none;">
            <div class="ql-editor" v-html="ruleForm.editContent">
            </div>
        </div>
      </el-dialog>

        <el-dialog title="选择取消发布时间" :visible.sync="select1" width="510px" >
          <el-date-picker
            v-model="ruleForm.informData"
            :disabled="isdisabled"
            class="informInput"
            style="margin-top:7px;margin-bottom:7px; text-align:center;margin-left: 80px;"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
          <el-time-picker
            v-model="ruleForm.timeData"
            :disabled="isdisabled"
            value-format="HH:mm:ss"
            class="timeSele"
            style="margin-top:7px;margin-bottom:7px;width:120px !important;"
            prefix-icon='none'
            placeholder="选择时间">
          </el-time-picker>
          <span slot="footer" class="dialog-footer">
            <el-button  style="min-width:80px;" @click="select1 = false">取 消</el-button>
            <el-button style="min-width:80px;margin-left:8px;" type="primary" @click="select1 = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog  class="informInputDialog" title="发布范围" :visible.sync="select2" width="650px" >
            <el-table
              class="informTable"
              :header-cell-style="{height:'40px'}"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              :show-header= 'false'
              height = '370px'
              @selection-change="handleSelectionChange"
              style="width: 100%">
            <el-table-column
              prop="customerName"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="" width="55" prop="" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isCheckbox"  :disabled="isdisabled" @change = 'handleSelectionChange(scope.row)' label=""></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
          
          <span slot="footer" class="dialog-footer">
            <el-button style="min-width:80px;" @click="select2 = false">取 消</el-button>
            <el-button style="min-width:80px;margin-left:8px;" type="primary" @click="select2 = false">确 定</el-button>
          </span>
        </el-dialog>
          <!-- 查看已读 -->
         <el-dialog  class="informInputDialog" title="已读详情" :visible.sync="select3" width="610px" >
            <el-table
              ref="multipleTable"
              :data="tableData1"
              tooltip-effect="dark"
              height = '360px'
              border
              style="width: 100%">
            <el-table-column
              prop="name"
              label="校企名称">
            </el-table-column>
            <el-table-column
              prop="readCount"
              label="已读"
              width="120">
            </el-table-column>
            <el-table-column
              prop="unReadCount"
              label="未读"
              width="120">
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button style="min-width:80px;" @click="select3 = false">取 消</el-button> -->
            <el-button style="min-width:80px;margin-left:8px;" type="primary" @click="select3 = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div style="height:56px;background:#ccc">
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span class="router_link" @click="linkIndex">通知公告</span><span class="arrow">></span><span>{{msg}}</span><span></span>
                            </div>
                            <div>
                                <el-button v-if="(pageType=='add'||pageType=='edit')&&isAuth('notice:saveNotice')" @click="issueClick(0)">保 存</el-button>
                                <el-button v-if="pageType=='look'&&pageSmallType=='exist'" type="primary" @click="stickClick()">{{ruleForm.enableText}}</el-button>
                                <el-button v-if="pageType=='look'&&pageSmallType=='exist'&&isAuth('notice:getNoticeRead')"  type="primary" @click="readBtn()">查看已读</el-button>
                                <el-button v-if="pageType=='look'&&pageSmallType=='del'&&isAuth('notice:updateNotice')" type="primary" @click="editClick()">编 辑</el-button>
                                <el-button v-if="pageType=='look'&&pageSmallType=='del'&&isAuth('notice:deleNotice')"  type="danger" @click="delBtn()">删 除</el-button>
                                <el-button @click="returnBtn()">返 回</el-button>
                            </div>
                        </div>
                    </div>
                    <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                      <el-form-item label="标题:" :required="true" style="margin-bottom: 40px !important;">
                        <el-input style="height:40px;"  v-if="pageType=='add'||pageType=='edit'" type="text"  class="titleCss" v-model="ruleForm.editValue" maxlength="30" minlength='2'  placeholder="长度在2-30个字符之间"  clearable></el-input>
                        <div v-if="pageType=='look'" style="line-height:32px;font-weight:bold;" class="select_radio">{{ruleForm.editValue}}</div>
                      </el-form-item>
                      
                      <el-form-item label="内容:" :required="true" style="position:relative;margin-right: 118px;margin-bottom: 40px !important;" >
                        <div v-if="pageType=='look'" class="ql-container ql-snow pageTypeLook" >
                            <div class="ql-editor" v-html="ruleForm.editContent">
                            </div>
                        </div>
                        <quill-editor v-show="pageType!='look'" v-model="ruleForm.editContent" ref="myQuillEditor1" @focus="onEditorFocus($event)" :options="editorOption1" @change="onEditorContentChange($event)" class="editor_content">
                        </quill-editor>
                        <span v-show="pageType!='look'" class="TiLength">{{TiLength}}/2000</span>
                      </el-form-item>

                      <el-form-item label="发布范围:" :required="true" class="item_input">
                        <div v-if="pageType=='add'||pageType=='edit'" class="select_radio">
                          <el-radio v-model="ruleForm.pushArea" label="1" @click.native="pushScopeC(1)">全部校区</el-radio>
                          <el-radio v-model="ruleForm.pushArea" label="2" @click.native="pushScopeC(2)" v-popover:popover4>自定义</el-radio>
                        </div>
                        <div v-if="pageType=='look'&& pageTypeShow==2" class="select_radio" @click="select2 = true">默认全部</div>
                        <div v-if="pageType=='look'&& pageTypeShow==1" class="select_radio" >{{ruleForm.checkSchool}}</div>
                      </el-form-item>

                      <el-form-item label="发布时效:" :required="true" class="item_input">
                        <div v-show="pageType=='add'||pageType=='edit'" class="select_radio">
                          <el-radio v-model="ruleForm.pushTime" @click.native="pushTimeC(1)" label="1">永久发布</el-radio>
                          <el-radio v-model="ruleForm.pushTime" @click.native="pushTimeC(2)" label="2" >自定义</el-radio>
                        </div>
                        <div v-show="pageType=='look'&&pageTypeShowT==2" class="select_radio">永久发布</div>
                        <div v-show="pageType=='look'&&pageTypeShowT==1" class="select_radio">{{ruleForm.informData}} {{ruleForm.timeData}}</div>
                      </el-form-item>

                      <el-form-item label="是否置顶:" :required="true" class="item_input" style="margin-bottom: 40px !important;">
                        <div v-if="pageType=='add'||pageType=='edit'"  class="select_radio">
                          <el-radio v-model="ruleForm.isTop" label="0">否</el-radio>
                          <el-radio style="    margin-left: 36.5px;" v-model="ruleForm.isTop" label="1">是</el-radio>
                          <span style="font-size:12px;color:#666;">（最多置顶三条，超出覆盖已置顶公告）</span>
                        </div>
                        <div v-if="pageType=='look'" class="select_radio"> {{ruleForm.isTopText}} <span style="font-size:12px;color:#666;margin-left:30px;">（最多置顶三条，超出覆盖已置顶公告）</span></div>
                      </el-form-item>

                      <el-form-item label="" :required="true" class="item_input"  style="margin-bottom: 40px !important;">
                        <el-button  v-if="pageType=='look'&&pageSmallType=='exist'&&isAuth('notice:cancePubNotice')" style="" type="primary" @click="cancelClick()">取消发布</el-button>

                        <el-button  v-if="(pageType=='add'||pageType=='look'&&pageSmallType=='del'||pageType=='edit')&&isAuth('notice:pubNoticeOrUnPub')||(pageType=='add'||pageType=='look'&&pageSmallType=='del'||pageType=='edit')&&isAuth('notice:publicNotice')"  style="" type="primary" @click="issueClick(1)">发 布</el-button>
                        <el-button style="margin-left:10px;" @click="previewClick()">预 览</el-button>
                      </el-form-item>

                    </el-form>
                    

                  <!--上传图片组件-->
                  <div class="upload_img" id="upload_img">
                    <el-upload
                      class="upload-demo"
                      accept="image/jpg,image/jpeg,image/png,image/JPG,image/JPEG,image/PNG,image/gif,image/GIF"
                      :action="upLoadAjaxUrl"
                      ref="uploadFileRef"
                      :before-upload="beforeUpload"
                      :on-progress="onProgress"
                      :show-file-list="false"
                      multiple
                      :on-success="successFile">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </div>

                  <!--上传视频组件-->
                  <!-- <div class="upload_video" id="upload_video">
                    <el-upload
                      class="upload-demo"
                      accept="video/MP4,video/WMV,video/FLV,video/rmvb,video/3gp,video/mov,video/m4v,video/mp4,video/wmv,video/flv"
                      :action="upLoadAjaxUrl"
                      ref="uploadFileVideoRef"
                      :before-upload="beforeUploadVideo"
                      :on-progress="onProgressVideo"
                      :show-file-list="false"
                      :on-success="successFileVideo"
                      >
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </div> -->

                  <!--图片进度条-->
                  <el-dialog
                    class="uploadDialog"
                    title="上传进度"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :modal-append-to-body="false"
                    :close-on-click-modal="false"
                  >
                    <span style="padding-right: 10px">{{basicIndex}}/{{allProgressSource}}</span>
                    <el-progress :percentage="uploadProgress" class="progress"></el-progress>
                    <span class="cancel" @click="cancelUpload">取消</span>
                  </el-dialog>

                  <!--视频进度条-->
                  <!-- <el-dialog
                    class="uploadDialog"
                    title="上传进度"
                    :visible.sync="dialogVisible1"
                    width="30%"
                    :modal-append-to-body="false"
                    :close-on-click-modal="false"
                  >
                    <span style="padding-right: 10px">0/1</span>
                    <el-progress :percentage="uploadVideoProgress" class="progress"></el-progress>
                    <span class="cancel" @click="cancelVideoUpload">取消</span>
                  </el-dialog> -->

                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import { quillEditor } from "vue-quill-editor"; // 导入quillEditor组件
    import {ajaxFuncJson} from '@/api/ajax';
    import {uploadNoticeFile,uploadIp} from '../../api/ajax'
    export default {
        name: 'editNotificate',
        data() {
            return {
              lock:true,
              routerURL:'',
              isBack:1,//点击面包屑
              TiLength:0,
              editData:[],//编辑对比的值
              informId:'',//公告的ID
              pageType:'',//页面的类型
              pageSmallType:'',//页面类型小分类
              isdisabled:false,//判断查看通知输入框禁止
              dialogType:'',//使用确认弹窗的类型
              select1:false,//时间弹窗
              select2:false,//发布范围弹窗
              select3:false,//已读未读弹窗
              pageTypeShow:1,//判断范围是否自定义
              pageTypeShowT:1,//判断时效是否自定义
              tableData: [],//校企
              tableData1:[],//已读数量
              tableSubmit: [],//提交的校企ID
              dialogTipsVisible:false, //自动消失提示
              dialogTipsSureVisible:false, //确认提示
              dialogTipsSureVisible1:false, //保存检查置顶确认提示
              dialogTipsBackVisible:false, //返回提示
              tips:'信息填写不完善，请完善信息！', //提示语
              tipsTwo:'本次编辑内容尚未保存，确定退出吗？', //确认提示语
              tipsBack:'', //返回提示语
              pickerOptions: {
                disabledDate(time) {
                  return time.getTime() < Date.now() - 8.64e7;//时间空间除去之前的时间
                },
              },
              pubNoticeOrUnPubType:"",//1.发布公告0.删除公告//2.取消置顶//3.取消发布
              typeSumbit:'',//'0:保存；1:发布'
              dialogVisible5:false,//预览
              msg: '编辑公告',
              editValue:'',
              ruleForm:{
                editValue:'',  //标题
                editContent:'',
                pushArea:'1',
                pushTime:'1',
                isTop:'0',
                scopeSeleD:[],//发布范围
                informData:'',//日期
                timeData:'',//时间
                loadData:'',//最终时间
                isTopText:'',//查看的是否置顶
                enableText:'',//是否置顶
                createDate:'',//创建时间
                publicDate:'',//发布时间
                checkSchool:'',//选中的学校
              },
              dialogVisible:false,
              dialogVisible1:false,
              upLoadAjaxUrl:uploadNoticeFile(),    //上传ip地址
              previewImg:uploadIp()+'/file/filePreview/',   //文件回显ip
              uploadFile:[],       //上传对象
              uploadType:'',      //定义上传的类型
              uploadProgress:0,     //图片上传进度
              uploadVideoProgress:0,  //视频上传进度
              editContentIndex:0,   //富文本光标的位置
              allProgressSource:0,
              checkedCities:[],
              fileList:[],
              selectTime:'',
              showSelectArea:false,
              showSelectTime:false,
              options: [],
              src:'',
              value: '',
              editContent:'',
              editorOption1:{
                placeholder:'',
                theme:'snow',
                modules:{
                  toolbar:{
                    container:[
                      [{ 'font': [] }],
                      [{ 'size': ['small', false, 'large', 'huge'] }],
                      [{ 'color': [] }, { 'background': [] }],
                      ['bold','italic','underline', 'strike'],
                      [{ 'align': [] }],
                      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                      [ 'image']
                    ],
                    handlers:{
                      'image': (value)=>{
                        if(value){
                          // this.editContent=this.$refs.myQuillEditor1.quill.getSelection();  //获取第二个富文本光标的位置
                          this.uploadType='image';
                          this.imgFile=[];
                          this.beforeUploadLength=[];
                          this.basicIndex=1;
                          document.getElementById('upload_img').getElementsByClassName("el-upload__input")[0].click();
                        }
                      },
                      // 'video': (value)=> {
                      //   if(value){
                      //     this.uploadType='video';
                      //     document.getElementById('upload_video').getElementsByClassName("el-upload__input")[0].click();
                      //     console.log(value);
                      //   }
                      // },
                    }
                  }
                },
              },
              id:'',
              uploadLength:0,     //上传图片的次数
              beforeUploadLength:[],   //上传之前获取所有图片的集合
              imgFile:[],    //图片取消上传的集合
              videoFile:[],    //视频取消上传的集合
              basicPercent:0,      //定义多选图片最开始的进度
              basicIndex:1,    //定义最开始上传的图片
            }
        },
        created(){
          this.init()
        },
        beforeRouteLeave (to, from , next) {
          if(to.path == '/notificate' || to.path == '/editNotificate'){
              this.lock = true;
              next();
          }else{
            
            this.routerURL =  to.path;
            if(!this.lock){
              next();
            }else{
                    this.lock = false;
                    if(this.$route.query.type==='add'){
                      if(this.ruleForm.editValue!=''||this.ruleForm.editContent!=''||this.ruleForm.scopeSeleD.length>0||this.ruleForm.informData||this.ruleForm.timeData){
                        // 标题
                        this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                        this.dialogTipsBackVisible = true;
                        return;
                      }
                        next();
                    }else if(this.$route.query.type==='edit'){      
                      var aa = this.ruleForm.informData + ' ' +this.ruleForm.timeData             
                      if(this.ruleForm.editValue!=this.editData.title||this.ruleForm.editContent!=this.editData.content||this.ruleForm.isTop!=this.editData.enable){
                        this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                        this.dialogTipsBackVisible = true;
                        return;
                      }
                      
                      if(this.editData.effectiveDate&&aa!=this.editData.effectiveDate||this.editData.effectiveDate&&this.ruleForm.pushTime!=2){
                        this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                        this.dialogTipsBackVisible = true;
                        return;
                      }
                      var isCheck = '';
                      this.tableData.forEach((item,index)=>{
                        if(item.isCheckbox){
                          isCheck+=item.id+','
                        }
                      })      
            
                      if(isCheck!=this.editData.customers||this.pageTypeShow==this.ruleForm.pushArea){
                        this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                        this.dialogTipsBackVisible = true;
                        return;
                      }
                      this.$router.push({path:'/editNotificate',query:{type:'未发布',id:this.informId}})
                      this.init()
                    }else {
                      if(sessionStorage.getItem('searName')){
                        sessionStorage.setItem('searnameType',1)
                      }else{
                        sessionStorage.setItem('searnameType',0)
                      }
                        next();
                    }
            }
                  
          }
          

        },
        methods: {
          // 刷新
          init(){
              if(this.$route.query.type=='add'){
                 this.findCustomer();
                this.msg='新增公告';
                this.pageType = 'add';
                this.isdisabled = false;
              }else if(this.$route.query.type=='已发布'||this.$route.query.type=='未发布'){
                this.findDeleCustomer()
                this.msg='查看公告';
                this.isdisabled = true;
                this.informId=this.$route.query.id;
                this.pageType = 'look';
                if(this.$route.query.type=='已发布'){
                  this.pageSmallType = 'exist'
                  if(this.isAuth('notice:getNoticeRead')){
                    this.getNoticeRead(); //查看已读未读
                  }
                }else if(this.$route.query.type=='未发布'){
                  this.pageSmallType = 'del'
                }
            
              }else if(this.$route.query.type=='edit'){
                 this.findCustomer();
                this.msg='编辑公告';
                this.pageType = 'edit';
                this.isdisabled = false;
              };
          },
          // 提示3秒消失
          hintWarn(obj){
            this.tips = obj;
            this.dialogTipsVisible = true;
            let that = this;
            let test1 = setTimeout(function(){ //提示框
                that.dialogTipsVisible = false;
                clearTimeout(test1);
            },3000)
          },
          // 发布时效弹窗
          pushTimeC(obj){
            if(obj==2){
              this.select1 = true;
            }
          },
          // 发布范围弹窗
          pushScopeC(obj){
            if(obj==2){
              this.select2 = true;
            }
          },
          //点击发布
          issueClick(obj){
            this.typeSumbit  = obj;
            this.tableSubmit = '';
            if(this.ruleForm.editValue==''||this.ruleForm.editValue.length==1){
              // 标题
              this.hintWarn('标题长度在2~30个字符之间，请完善信息！')
              return;
            } 
            if(this.ruleForm.editContent==''||this.ruleForm.editContent.length==2000){
              // 内容
              this.hintWarn('内容不可为空，请完善信息！')
              return;
            }
            if(this.ruleForm.pushArea==2){ // 发布范围
              if(this.ruleForm.scopeSeleD.length==0){
                this.hintWarn('请选择发布范围！')
                return;
              }else{
                this.ruleForm.scopeSeleD.forEach((item,index)=>{
                  this.tableSubmit+=item.id+','
                })
              }
            }else if(this.ruleForm.pushArea==1){
              // 发布范围全部校区
              this.tableData.forEach((item,index)=>{
                this.tableSubmit+=item.id+','
              })
            }           
            if(this.ruleForm.pushTime==2){
              // 发布时效果
              if(!this.ruleForm.informData){
                this.hintWarn('请选择发布时效！')
                return;
              }
              if(!this.ruleForm.timeData){
                this.hintWarn('请选择发布时效！')
                return;
              }
              var startTime= new Date().getTime();
              var nowDate = this.ruleForm.informData.replace(/-/g,'/') + ' ' +this.ruleForm.timeData

              var nowDateC = new Date(nowDate).getTime()
              
              if(startTime>nowDateC){
                this.hintWarn('请选择合理发布时效！')
                return;
              }
              this.ruleForm.loadData = new Date(this.ruleForm.informData + ' ' +this.ruleForm.timeData) ;
            }else if(this.ruleForm.pushTime==1){
              // 发布时效选择啦永久发布
              this.ruleForm.loadData = ''
            }
            if(obj==1){
              this.tipsTwo = '是否确定发布当前公告？'
              this.dialogTipsSureVisible = true;

            }else if(obj==0&&this.pageType== 'add'){
              if(this.ruleForm.isTop==1){
                this.dialogTipsSureVisible1 = true;
                return;
              }
              this.saveNotice();
            }else if(obj==0&&this.pageType== 'edit'){
              if(this.ruleForm.isTop==1){
                this.dialogTipsSureVisible1 = true;
                return;
              }
              this.updateNotice();
            }
          },
          TipsSure1(){ //保存未发布时，无法置顶确定保存
            this.ruleForm.isTop=0;
            this.dialogTipsSureVisible1 = false;
            if(this.pageType== 'add'){
              this.saveNotice();
            }else if(this.pageType== 'edit'){  
              this.updateNotice();
            }
          },
          editClick(){ //编辑
            this.$router.push({path:'/editNotificate',query:{type:'edit',id:this.informId}})
            this.init()
          },
          TipsSure(){// 点击保存确定提交
            let parmas = ''
            if(this.pageType== 'add'){
              this.publicNotice();
            }else if(this.pageType== 'look'&&this.pageSmallType== 'del'){
              if(this.tipsTwo == '是否确定删除当前公告？'){
                this.pubNoticeOrUnPubType = 0
                parmas = ''
                this.deleNotice()
              }else if(this.tipsTwo == '是否确定发布当前公告？'){
                this.pubNoticeOrUnPubType = 1
                parmas = ''
                this.pubNoticeOrUnPub(parmas);
              }
              
            }else if(this.pageType== 'look'&&this.pageSmallType== 'exist'){
              if(this.tipsTwo == '是否确定取消发布当前公告？'){
                this.pubNoticeOrUnPubType = 3
                parmas = ''
                this.cancePubNotice(parmas);
              }else if(this.tipsTwo == '是否确定取消置顶当前通知？'){
                this.pubNoticeOrUnPubType = 2
                parmas = 0;
                this.pubNoticeOrUnPub(parmas);
              }else if(this.tipsTwo == '是否确定置顶当前通知？'){
                this.pubNoticeOrUnPubType = 2
                parmas = 1;
                this.pubNoticeOrUnPub(parmas);
              }
              
            }else if(this.pageType=='edit'){
              this.updateNotice();
            };
            
            this.dialogTipsSureVisible = false;
          },
          delBtn(){ // 点击删除
            this.tipsTwo = '是否确定删除当前公告？'
            this.dialogTipsSureVisible = true;
          },
          cancelClick(){ //取消发布
            this.tipsTwo = '是否确定取消发布当前公告？'
            this.dialogTipsSureVisible = true;
          },
          readBtn(){ //查看已读
            this.select3 = true;
          },
          stickClick(){ //置顶or取消置顶
            if(this.ruleForm.isTopText=='是'){
              //按钮未取消置顶
              this.tipsTwo = '是否确定取消置顶当前通知？'
              this.dialogTipsSureVisible = true;
            }else if(this.ruleForm.isTopText=='否'){
              //按钮为置顶
              this.tipsTwo = '是否确定置顶当前通知？'
              this.dialogTipsSureVisible = true;
            }
          },
          previewClick(){ // 点击预览
            if(this.ruleForm.editValue==''||this.ruleForm.editContent==''){
              this.hintWarn('标题和内容不可为空！')
              return;
            }
            this.dialogVisible5 = true;
          },
          returnBtn(url){ //返回按钮
            if(this.$route.query.type==='add'){
              if(this.ruleForm.editValue!=''||this.ruleForm.editContent!=''||this.ruleForm.scopeSeleD.length>0||this.ruleForm.informData||this.ruleForm.timeData){
                // 标题
                this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                this.dialogTipsBackVisible = true;
                return;
              }
                this.$router.push({path:'/notificate'})
            }else if(this.$route.query.type==='edit'){      
              var aa = this.ruleForm.informData + ' ' +this.ruleForm.timeData             
              if(this.ruleForm.editValue!=this.editData.title||this.ruleForm.editContent!=this.editData.content||this.ruleForm.isTop!=this.editData.enable){
                this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                this.dialogTipsBackVisible = true;
                return;
              }
              
              if(this.editData.effectiveDate&&aa!=this.editData.effectiveDate||this.editData.effectiveDate&&this.ruleForm.pushTime!=2){
                this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                this.dialogTipsBackVisible = true;
                return;
              }
              var isCheck = '';
              this.tableData.forEach((item,index)=>{
                if(item.isCheckbox){
                  isCheck+=item.id+','
                }
              })      
    
              if(isCheck!=this.editData.customers||this.pageTypeShow==this.ruleForm.pushArea){
                this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                this.dialogTipsBackVisible = true;
                return;
              }
              this.$router.push({path:'/editNotificate',query:{type:'未发布',id:this.informId}})
              this.init()
            }else {
              if(sessionStorage.getItem('searName')){
                sessionStorage.setItem('searnameType',1)
              }else{
                sessionStorage.setItem('searnameType',0)
              }
                this.$router.push({path:'/notificate'});
            }
          },
          // 点击不保存
          BackSaveNo(){
            if(this.$route.query.type==='edit'){
              if(this.lock){
                this.$router.push({path:'/editNotificate',query:{type:'未发布',id:this.informId}})
              }else{
                this.$router.push({path:this.routerURL})
              }
              this.init()
            }else{
              if(this.lock){
                this.$router.push({path:'/notificate'})
              }else{
                this.$router.push({path:this.routerURL})
              }
            }
            this.dialogTipsBackVisible = false;
          },
         
          // 发布范围选中
          handleSelectionChange(val){
            this.ruleForm.scopeSeleD = []
            this.tableData.forEach((item,index)=>{
              if(item.isCheckbox){
                this.ruleForm.scopeSeleD.push(item);
              }
            })
          },
          // ===========查看公告方法============
          //富文本是否禁止编辑 
          onEditorFocus(event){
            if(this.msg=='查看公告'){
              event.enable(false);
            }else{
              event.enable(true);
            }
          },
          onEditorContentChange(editor){
            editor.quill.deleteText(2000,4);
            if(this.ruleForm.editContent==''){
              this.TiLength = 0
            }else{
              this.TiLength = editor.quill.getLength() - 1
            }

            if(editor.html.indexOf('ql-video')!==-1){
              $('.editor_content').find('.ql-video').attr('disabled','disabled')
            }else {
              $('.editor_content').find('.ql-video').removeAttr('disabled')
            }
           this.getImgNum(editor.html,0);
          },
          //获取img在文本的个数
          getImgNum(text,length){
            if(text.indexOf('img')!==-1){
              text.substring(text.indexOf('img')+3);
              length=length+1;
              this.getImgNum(text.substring(text.indexOf('img')+3),length);
            }else {
              if(length===10){
                $('.editor_content').find('.ql-image').attr('disabled','disabled')
              }else {
                $('.editor_content').find('.ql-image').removeAttr('disabled')
              }
              this.uploadLength=length;
            }
          },
          //上传之前的回调
          beforeUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(!isLt2M) {
              this.hintWarn('单张图片不得超过2MB！')
              return false;
            }
            this.beforeUploadLength.push(file);
            this.imgFile.push(file);
            this.uploadProgress=0;
            this.allProgressSource=this.beforeUploadLength.length;
            if(this.beforeUploadLength.length>10){
              this.allProgressSource=10;
            }
          },
          // //上传视频之前的回调
          // beforeUploadVideo(file){
          //   const isLt2M = file.size / 1024 / 1024 < 100;
          //   if(!isLt2M) {
          //     this.$message({
          //       message: '单个视频不得超过100MB！',
          //       type: 'warning'
          //     });
          //     return false;
          //   }
          //   this.videoFile=file;
          //   this.uploadVideoProgress=0;
          //   this.dialogVisible1=true;
          // },
          //上传进度
          onProgress(event,file,fileList){
            // this.basicPercent=parseInt(event.percent)+this.basicPercent;
            if(this.uploadLength<=10){
              this.dialogVisible=true;
            }
            this.uploadProgress=this.uploadProgress+(this.basicIndex-1)*(100/this.allProgressSource)+1;
            if(this.uploadProgress>=(this.allProgressSource-1)/this.allProgressSource*100+1){
              this.uploadProgress=95;
            }
          },
          // //上传视频进度
          // onProgressVideo(event,file,fileList){
          //     this.uploadVideoProgress=parseInt(event.percent);
          // },
          // //取消上传视频进度
          // cancelVideoUpload(){
          //   this.dialogVisible1=false;
          //   this.$refs.uploadFileVideoRef.abort(this.videoFile);
          // },
          // //上传视频成功回调
          // successFileVideo(response, file, fileList){
          //   if(response.status==200){
          //     this.dialogVisible1=false;
          //     let url=this.previewImg + response.data.fileId;
          //     if(url!=null&&url.length>0){
          //       let value=url;
          //       this.editContent = this.$refs.myQuillEditor1.quill.getSelection();
          //       value = value.indexOf('http') !== -1 ? value : 'http:' + value;
          //       this.$refs.myQuillEditor1.quill.insertEmbed(this.editContent !== null ? this.editContent.index : 0, this.uploadType, value); // 调用编辑器的 insertEmbed 方法，插入URL
          //       // console.log(this.editContent);
          //       this.$refs.myQuillEditor1.quill.setSelection(this.editContent.index + 1, 0);
          //     } else {
          //       this.$message.error('插入失败')
          //     }
          //   }
          // },
          //上传文件成功回调
          successFile(response, file, fileList){
            if(response.status==200){
              ++this.uploadLength;
              ++this.basicIndex;
              if(this.basicIndex>=this.allProgressSource+1){
                this.basicIndex=this.allProgressSource;
                this.uploadProgress=100;
                this.dialogVisible=false;
              }
              if(this.uploadLength<=10){
                let url='';
                if (this.uploadType === 'image') { // 获得文件上传后的URL地址
                  url = this.previewImg + response.data.fileId;
                } else if (this.uploadType === 'video') {
                  url = this.previewImg + response.data.fileId;
                }
                if(url!=null&&url.length>0){
                  let value=url;
                  this.editContent = this.$refs.myQuillEditor1.quill.getSelection();
                  value = value.indexOf('http') !== -1 ? value : 'http:' + value;
                  this.$refs.myQuillEditor1.quill.insertEmbed(this.editContent !== null ? this.editContent.index : 0, this.uploadType, value); // 调用编辑器的 insertEmbed 方法，插入URL
                  // console.log(this.editContent);
                  this.$refs.myQuillEditor1.quill.setSelection(this.editContent.index + 1, 0);
                } else {
                  this.$message.error('插入失败')
                  
                }
              }else {
                this.hintWarn('最多只能上传10张图片！')
              }
              if(this.uploadLength===10){
                this.imgFile=this.beforeUploadLength.slice(10,this.beforeUploadLength.length);
                this.imgFile.forEach((item,index)=>{
                  this.$refs.uploadFileRef.abort(item);
                });
              }
              // this.$refs['uploadFileRef'].clearFiles() // 插入成功后清除input的内容
            }else {
              this.$message({
                message:response.msg,
                type:'error'
              })
            }

          },
          // 取消上传
          cancelUpload() {
            this.dialogVisible = false;
            this.imgFile.forEach((item,index)=>{
              this.$refs.uploadFileRef.abort(item);
            });
            this.imgFile=[];
            this.beforeUploadLength=[];
          },    
           //新增发布公告
          publicNotice(){
                var than = this;
               let parmas = {
                'id' :this.informId, //公告id
                'title' :this.ruleForm.editValue,//公告标题
                'content' :this.ruleForm.editContent,//公告内容
                'photoId' :'',//公告照片
                'createDate' :'',//公告单创建时间
                'effectiveDate' :this.ruleForm.loadData,//公告单有效时间时间
                'customers' :this.tableSubmit,//校区id多个学校用,分隔
                'enable':this.ruleForm.isTop, //是否置顶0否1是'
                'dealStatus' :this.typeSumbit,//'0:保存；1:发布
                'publicDate' :'',//发布时间
                'customerId' :'',//客户id
                'createUserId' :'', //创建者
              }
              ajaxFuncJson('/notice/publicNotice',parmas).then(res=>{
                if(res.data.status==200){
                  if(this.typeSumbit==1){
                    this.hintWarn('发布成功')
                  }else{
                    this.hintWarn('保存成功')
                  }                  
                  let setTimeFref = setTimeout(function(){
                    if(than.typeSumbit==1){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:res.data.data}})
                      than.init()
                    }else{
                      than.$router.push({path:'/editNotificate',query:{type:'未发布',id:res.data.data}})
                      than.init()
                    }
                    clearTimeout(setTimeFref);
                  },2500)
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
           //新增保存公告
          saveNotice(){
                var than = this;
               let parmas = {
                'id' :this.informId, //公告id
                'title' :this.ruleForm.editValue,//公告标题
                'content' :this.ruleForm.editContent,//公告内容
                'photoId' :'',//公告照片
                'createDate' :'',//公告单创建时间
                'effectiveDate' :this.ruleForm.loadData,//公告单有效时间时间
                'customers' :this.tableSubmit,//校区id多个学校用,分隔
                'enable':this.ruleForm.isTop, //是否置顶0否1是'
                'dealStatus' :this.typeSumbit,//'0:保存；1:发布
                'publicDate' :'',//发布时间
                'customerId' :'',//客户id
                'createUserId' :'', //创建者
              }
              ajaxFuncJson('/notice/saveNotice',parmas).then(res=>{
                if(res.data.status==200){
                  this.dialogTipsBackVisible = false;
                  if(this.typeSumbit==1){
                    this.hintWarn('发布成功')
                  }else{
                    this.hintWarn('保存成功')
                  }
                  
                  let setTimeFref = setTimeout(function(){
                    if(than.typeSumbit==1){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:res.data.data}})
                      than.init()
                    }else{
                      if(than.lock){
                        than.$router.push({path:'/editNotificate',query:{type:'未发布',id:res.data.data}})
                      }else{
                        than.$router.push({path:than.routerURL})
                      }
                      than.init()
                    }
                    clearTimeout(setTimeFref);
                  },2500)
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
            //编辑公告
          updateNotice(){
              var than = this;
               let parmas = {
                'id' :this.informId, //公告id
                'title' :this.ruleForm.editValue,//公告标题
                'content' :this.ruleForm.editContent,//公告内容
                'photoId' :'',//公告照片
                'createDate' :'',//公告单创建时间
                'effectiveDate' :this.ruleForm.loadData,//公告单有效时间时间
                'customers' :this.tableSubmit,//校区id多个学校用,分隔
                'enabled': parseInt(this.ruleForm.isTop), //是否置顶0否1是'
                'dealStatus' :this.typeSumbit,//'0:保存；1:发布
                'publicDate' :'',//发布时间
                'customerId' :'',//客户id
                'createUserId' :'', //创建者
              }
              ajaxFuncJson('/notice/updateNotice',parmas).then(res=>{
                if(res.data.status==200){
                  this.dialogTipsBackVisible = false;
                  if(this.typeSumbit==1){
                    this.hintWarn('发布成功')
                  }else{
                    this.hintWarn('保存成功')
                  }
                  let setTimeFref = setTimeout(function(){
                    if(than.typeSumbit==1){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:than.informId}})
                      than.init()
                    }else{
                      if(than.lock){
                        than.$router.push({path:'/editNotificate',query:{type:'未发布',id:than.informId}})
                      }else{
                        than.$router.push({path:than.routerURL});
                      }
                      than.init()
                    }
                    clearTimeout(setTimeFref);
                  },2500)
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
          //未发布前去发布公告
          pubNoticeOrUnPub(obj){
                var than = this;
               let parmas = {
                'id' :this.informId, //公告id
                'dealStatus' :this.pubNoticeOrUnPubType,//Body	1.发布公告0.删除公告//2.取消置顶//3.取消发布
                'enabled' :obj,//用于取消置顶传1置顶

              }
              ajaxFuncJson('/notice/pubNoticeOrUnPub',parmas).then(res=>{
                if(res.data.status==200){
                  // this.ruleForm.isTopText=='是'

                  if(this.pubNoticeOrUnPubType==1){
                      this.hintWarn('发布成功');
                  }else if(this.pubNoticeOrUnPubType==0){
                      this.hintWarn('删除成功');
                  }else if(this.pubNoticeOrUnPubType==3){
                      this.hintWarn('取消成功');
                  }else if(this.pubNoticeOrUnPubType==2){
                    if(this.ruleForm.isTopText=='是'){
                      this.hintWarn('取消置顶成功');
                    }else if(this.ruleForm.isTopText=='否'){
                      this.hintWarn('置顶成功');
                    }
                  };
                  
                  
                  let setTimeFref = setTimeout(function(){
                    if(than.pubNoticeOrUnPubType==1){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:res.data.data.id}})
                      than.init()
                    }else if(than.pubNoticeOrUnPubType==0){
                      than.$router.push({path:'/notificate'})
                    }else if(than.pubNoticeOrUnPubType==3){
                      than.$router.push({path:'/editNotificate',query:{type:'未发布',id:than.informId}})
                      than.init()
                    }else if(than.pubNoticeOrUnPubType==2){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:than.informId}})
                      than.init()
                    }
                    clearTimeout(setTimeFref);
                  },2500)
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
           //未发布前去发布公告
          deleNotice(){
              var than = this;
              let parmas = {
              'id' :this.informId, //公告id
            }
            ajaxFuncJson('/notice/deleNotice',parmas).then(res=>{
              if(res.data.status==200){
                if(this.pubNoticeOrUnPubType==0){
                    this.hintWarn('删除成功');
                }
                
                
                let setTimeFref = setTimeout(function(){
                  if(than.pubNoticeOrUnPubType==1){
                    than.$router.push({path:'/editNotificate',query:{type:'已发布',id:res.data.data.id}})
                    than.init()
                  }else if(than.pubNoticeOrUnPubType==0){
                    than.$router.push({path:'/notificate'})
                  }else if(than.pubNoticeOrUnPubType==3){
                    than.$router.push({path:'/editNotificate',query:{type:'未发布',id:than.informId}})
                    than.init()
                  }else if(than.pubNoticeOrUnPubType==2){
                    than.$router.push({path:'/editNotificate',query:{type:'已发布',id:than.informId}})
                    than.init()
                  }
                  clearTimeout(setTimeFref);
                },2500)
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            });
          },
          //未发布前去取消发布
          cancePubNotice(obj){
                var than = this;
               let parmas = {
                'id' :this.informId, //公告id
                'dealStatus' :this.pubNoticeOrUnPubType,//Body	1.发布公告0.删除公告//2.取消置顶//3.取消发布
                'enabled' :obj,//用于取消置顶传1置顶

              }
              ajaxFuncJson('/notice/cancePubNotice',parmas).then(res=>{
                if(res.data.status==200){
                  // this.ruleForm.isTopText=='是'

                  if(this.pubNoticeOrUnPubType==1){
                      this.hintWarn('发布成功');
                  }else if(this.pubNoticeOrUnPubType==0){
                      this.hintWarn('删除成功');
                  }else if(this.pubNoticeOrUnPubType==3){
                      this.hintWarn('取消成功');
                  }else if(this.pubNoticeOrUnPubType==2){
                    if(this.ruleForm.isTopText=='是'){
                      this.hintWarn('取消置顶成功');
                    }else if(this.ruleForm.isTopText=='否'){
                      this.hintWarn('置顶成功');
                    }
                  };
                  
                  
                  let setTimeFref = setTimeout(function(){
                    if(than.pubNoticeOrUnPubType==1){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:res.data.data.id}})
                      than.init()
                    }else if(than.pubNoticeOrUnPubType==0){
                      than.$router.push({path:'/notificate'})
                    }else if(than.pubNoticeOrUnPubType==3){
                      than.$router.push({path:'/editNotificate',query:{type:'未发布',id:than.informId}})
                      than.init()
                    }else if(than.pubNoticeOrUnPubType==2){
                      than.$router.push({path:'/editNotificate',query:{type:'已发布',id:than.informId}})
                      than.init()
                    }
                    clearTimeout(setTimeFref);
                  },2500)
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
          //获取所有校企
          findCustomer(){
                if(sessionStorage.getItem("userType") == 3||sessionStorage.getItem("userType") == 4){
                  var parmas = {
                    customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
                  }
                }else{
                    var parmas = {
                  }
                }
              ajaxFuncJson('/notice/findCustomer',parmas).then(res=>{
                if(res.data.status==200){
                  
                  res.data.data.forEach((item,index)=>{
                    item.isCheckbox =false;
                  })
                    this.tableData = res.data.data;

                  if(this.$route.query.type==='已发布'||this.$route.query.type==='未发布'||this.$route.query.type==='edit'){
                    this.findNoticeById();
                  };
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
          //获取所有校企
          findDeleCustomer(){
              ajaxFuncJson('/notice/findDeleCustomer','').then(res=>{
                if(res.data.status==200){
                  
                  res.data.data.forEach((item,index)=>{
                    item.isCheckbox =false;
                  })
                    this.tableData = res.data.data;

                  if(this.$route.query.type==='已发布'||this.$route.query.type==='未发布'||this.$route.query.type==='edit'){
                    this.findNoticeById();
                  };
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
          //获取校区已读未读数量
          getNoticeRead(){
            let params={
              id:this.informId,
            };
            ajaxFuncJson('/notice/getNoticeRead',params).then(res=>{
              if(res.data.status==200){         
                  this.tableData1 = res.data.data;
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            });
          },
          //ID获取公告
          findNoticeById(){
              let params={
                id:this.informId,
              };
            ajaxFuncJson('/notice/findNoticeById',params).then(res=>{
              if(res.data.status==200){
                if(this.$route.query.type==='edit'){
                  this.editData = res.data.data;
                }
                this.ruleForm.editValue = res.data.data.title;
                this.ruleForm.editContent = res.data.data.content;
                this.$refs.myQuillEditor1.quill.setSelection(false);//取消光标
                this.ruleForm.createDate = res.data.data.createDate;
                if(res.data.data.publicDate){
                  this.ruleForm.publicDate = res.data.data.publicDate;
                }else{
                  this.ruleForm.publicDate = '--';
                }
                
                if(res.data.data.enable){
                  res.data.data.enable = '1';
                  this.ruleForm.isTopText = '是'
                  this.ruleForm.enableText = '取消置顶'
                }else{
                  res.data.data.enable = '0';
                  this.ruleForm.isTopText = '否'
                  this.ruleForm.enableText = '置 顶'
                };

                this.ruleForm.isTop = res.data.data.enable;
                this.ruleForm.checkSchool = '';
                if(res.data.data.customers){
                  res.data.data.customers.split(',').forEach((item,index)=>{
                    this.tableData.forEach((item1,index1)=>{
                      if(item==item1.id){
                        item1.isCheckbox = true;
                        this.ruleForm.checkSchool+=item1.customerName+','
                      }
                    })
                  })

                  this.ruleForm.checkSchool=    this.ruleForm.checkSchool.substr(0,this.ruleForm.checkSchool.length-1)
                }
                // ruleForm.pushArea
                if(this.tableData.length==res.data.data.customers.split(',').length-1){
                  this.pageTypeShow = 2;
                  this.ruleForm.pushArea = '1';
                }else{
                  this.pageTypeShow = 1;
                  this.ruleForm.pushArea = '2';
                  if(this.$route.query.type==='edit'||this.$route.query.type==='未发布'){
                    this.ruleForm.scopeSeleD = []
                    this.tableData.forEach((item,index)=>{
                      if(item.isCheckbox){
                        this.ruleForm.scopeSeleD.push(item);
                      }
                    })
                  }
                }

                if(!res.data.data.effectiveDate){
                  this.pageTypeShowT = 2
                  this.ruleForm.pushTime = '1';   
                }else{
                  this.pageTypeShowT = 1
                  res.data.data.effectiveDate = new Date(res.data.data.effectiveDate).Format('yy-MM-dd hh:mm:ss'); //"2018-11-15 17:40:00"
                  let effectiveDate = res.data.data.effectiveDate.split(' ');
                  this.ruleForm.informData = effectiveDate[0];
                  this.ruleForm.timeData = effectiveDate[1];
                  this.ruleForm.pushTime = '2';

                }
              }else {
                this.$message({
                  message: res.data.msg,
                  type:'error'
                })
              }
            })
          },
            //路由跳转
            linkIndex(){
              if(this.$route.query.type==='add'){
                if(this.ruleForm.editValue!=''||this.ruleForm.editContent!=''||this.ruleForm.scopeSeleD.length>0||this.ruleForm.informData||this.ruleForm.timeData){
                  // 标题
                  this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                  this.dialogTipsBackVisible = true;
                  return;
                }
                this.$router.push({path:'/notificate'})
              }else if(this.$route.query.type==='edit'){      
                var aa = this.ruleForm.informData + ' ' +this.ruleForm.timeData             
                if(this.ruleForm.editValue!=this.editData.title||this.ruleForm.editContent!=this.editData.content||this.ruleForm.isTop!=this.editData.enable){
                  this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                  this.dialogTipsBackVisible = true;
                  return;
                }
                
                if(this.editData.effectiveDate&&aa!=this.editData.effectiveDate||this.editData.effectiveDate&&this.ruleForm.pushTime!=2){
                  this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                  this.dialogTipsBackVisible = true;
                  return;
                }
                var isCheck = '';
                this.tableData.forEach((item,index)=>{
                  if(item.isCheckbox){
                    isCheck+=item.id+','
                  }
                })          
                if(isCheck!=this.editData.customers||this.pageTypeShow==this.ruleForm.pushArea){
                  this.tipsBack= '本次编辑内容尚未保存，是否保存后再退出？'
                  this.dialogTipsBackVisible = true;
                  return;
                }
                 this.$router.push({path:'/notificate'})
                this.init()
              }else {
                this.$router.push({path:'/notificate'})
              }
            },
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    .TiLength{
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 12px;
    }
    .pageTypeLook{
      max-height: 510px;
      overflow-y: auto;
    }
    /*修改滚动条样式*/
    .pageTypeLook::-webkit-scrollbar{
      width:4px;
      height:10px;
      /**/
    }
    .pageTypeLook::-webkit-scrollbar-track{
      background: rgb(239, 239, 239);
      border-radius:2px;
    }
    .pageTypeLook::-webkit-scrollbar-thumb{
      background: #ddd;
      border-radius:10px;
    }
    .pageTypeLook::-webkit-scrollbar-thumb:hover{
      background: #e2dfdf;
    }
    .pageTypeLook::-webkit-scrollbar-corner{
      background: #179a16;
    }
    /*修改滚动条样式*/
    .ql-editor::-webkit-scrollbar{
      width:4px;
      height:10px;
      /**/
    }
    .ql-editor::-webkit-scrollbar-track{
      background: rgb(239, 239, 239);
      border-radius:2px;
    }
    .ql-editor::-webkit-scrollbar-thumb{
      background: #ddd;
      border-radius:10px;
    }
    .ql-editor::-webkit-scrollbar-thumb:hover{
      background: #e2dfdf;
    }
    .ql-editor::-webkit-scrollbar-corner{
      background: #179a16;
    }
    /*修改滚动条样式*/
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar{
      width:4px;
      height:10px;
      /**/
    }
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track{
      background: rgb(239, 239, 239);
      border-radius:2px;
    }
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb{
      background: #ddd;
      border-radius:10px;
    }
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb:hover{
      background: #e2dfdf;
    }
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-corner{
      background: #179a16;
    }
    
    
    
    .msgHtml{
      position: absolute;
      width: 100%;
      height:50px;
      background: rgba(255, 255,255, 0);
      z-index: 1000000000; 
    }
    .titleCss{
      width: 300px !important;
    }
    .titleCss .el-input__inner{
      height: 40px !important;
    }
    #editNotificate{
      .el-date-editor.el-input, .el-date-editor.el-input__inner{
          width: 180px !important;
      }
    }
    // .el-table tr:hover{
    //   background: #f2f9ff !important;
    // }
    .el-table--enable-row-hover .el-table__body tr:hover>td {
       background: #f2f9ff !important;
    }
    
     .informInput .el-input__inner{
      width: 180px !important;
       text-align: center;
    }
    .timeSele .el-input__inner{
       width: 120px !important;
       text-align: center;
    }
    .informTable {
      border: 1px solid #EBEEF5;
      border-bottom: none;
    }
    .el-input__inner{
      border-color: #ccc;
    }
    #editNotificate {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                padding: 10px 20px 10px 20px;
                background: #f2f2f2;
                .el-row {
                    background: #fff;
                    // height: 112%;
                  .mainHead{
                    margin-right: 0;
                  }
                  .edit_form{
                    padding-top: 20px;
                    padding-left: 40px;
                  }
                  .upload_img{
                    opacity: 0;
                  }
                  .upload_video{
                    opacity: 0;
                  }
                }
            }
        }
      .demo-ruleForm{
        width: 1240px;
        margin: 40px auto;
        .el-form-item--small .el-form-item__content{
          line-height: 1;
        }
        .show_school{
          border: 1px solid #ddd;
          height: 100px;
          overflow: auto;
          padding: 10px;
          .school_list{
            height: 30px;
          }
        }
        .editor_content{
          .ql-container{
            height:510px;
          }
        }
        .select_time{
          .el-input{
            width: 300px;
            .el-input__inner{
              padding-left: 30px!important;
            }
          }
          .time_tip{
            padding-left: 10px;
          }
        }
      }
      .demo-ruleForm.el-form .item_input{
        margin-bottom: 40px!important;
        .select_radio{
          line-height: 32px;
          cursor: pointer;
        }
      }
      .uploadDialog .el-progress-bar {
        width: 364px;
      }
      .uploadDialog .el-dialog {
        width: 510px !important;
        height: 172px !important;
        .progress{
            display: inline-block;
        }
      }
      .uploadDialog .el-dialog .el-dialog__headerbtn {
        display: none;
      }
      .uploadDialog .el-dialog .el-dialog__body{
        height: 80px;
        padding: 50px 40px 0 40px !important;
        .el-progress-bar__outer {
          width: 100%;
        }
        .el-progress__text {
          margin-left:12px;
        }
      }
      .uploadDialog .el-dialog .el-dialog__header {
        padding: 20px 20px 0 20px;
      }
      .uploadDialog .el-dialog .cancel{
        position: absolute;
        top: 97px;
        color: #198cff;
        right: 40px;
        cursor: pointer;
      }
    }
    .router_link:hover{
      cursor: pointer;
      color: #198cff;
    }
    .submit_userInfo{
      padding-left: 120px;
    }
    .el-form {
        margin-top: 20px;
      .el-form-item__label{
        padding: 0 20px 0 0;
      }
      .el-form-item__label:before{
        color: #f55353!important;
      }
    }
    .editor {
      line-height: normal !important;
      height: 800px;
    }
    .ql-snow .ql-tooltip[data-mode=link]::before {
      content: "请输入链接地址:";
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .previewLogW{
      position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -30%;
      width: 60%;
      min-height: 300px;
      min-height: calc(100%);
      background: #ccc;
      z-index: 2;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: '14px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
      content: '10px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
      content: '18px';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
      content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
      content: '文本';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
      content: '标题1';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
      content: '标题2';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
      content: '标题3';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
      content: '标题4';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
      content: '标题5';
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
      content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
      content: '微软雅黑';
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
      content: '衬线字体';
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
      content: '等宽字体';
    }










    
</style>



// WEBPACK FOOTER //
// src/page/notificate/editNotificate.vue